module.exports = __webpack_public_path__ + "static/img/RocMoS.bd9ad6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/RocMoS.png
// module id = WHJY
// module chunks = 1